/**
 * @file _initialize/_accordion.js
 */
(function ($) {
	'use strict';
		var ApplyClass = require('../_util/_apply-class');
		var SmoothScroll = require('../_view/_smoothScroll');

	/**
	 * recruit formのaccordion 初期化
	 * @return {undefined}
	 */


	var SmoothScrollInitialize = function () {
		$(function () {
			applyClass();
		});
	};

	/**
	 * Recruit Form の各項目をアコーディオンさせる
	 */
	var applyClass = function (idx, e) {
		$('.list--archives').each(function() {
			var $e = $(e);
			ApplyClass.apply(SmoothScroll, $e);
		});
	};

	module.exports = SmoothScrollInitialize;
})(jQuery);
